/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/shipyard_2_orbital': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M18.801 10L16 15.6 13.199 10z"/><path pid="1" d="M11.201 10L16 19.601 20.799 10H24l-8.013 16L8 10zM13 8h6v1h-6zM15 5h2v2h-2zM15 32H0V17h1v14h14zM32 32H17v-1h14V17h1zM32 15h-1V1H17V0h15zM1 15H0V0h15v1H1z"/>'
  }
})
